export const CALENDAR_CALLBACK_PARAM = 'calendar';
export const CALENDAR_CALLBACK_REASON_PARAM = 'reason';
export const CALENDAR_CALLBACK_EMPLOYEE_PARAM = 'employeeId';

export const CALENDAR_CALLBACK_STATUS = {
  CONNECTED: 'connected',
  ERROR: 'error',
} as const;

export const CALENDAR_CALLBACK_REASON = {
  SCOPES: 'scopes',
} as const;

export const GOOGLE_CALENDAR_CONNECTION_STATUS = {
  ACTIVE: 'Active',
  ERROR: 'Error',
  REVOKED: 'Revoked',
} as const;

export const GOOGLE_CALENDAR_BLOCK_LABEL = 'Wydarzenie Google';

export const GOOGLE_CALENDAR_REVOKE_REASON = {
  TOKEN_REVOKED: 'TokenRevoked',
  INSUFFICIENT_SCOPES: 'InsufficientScopes',
  CALENDAR_NOT_FOUND: 'CalendarNotFound',
} as const;
